// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__Cz3ua","actions":"GroupTable_actions__tihMR","deleteModalFooter":"GroupTable_deleteModalFooter__2jcDL"};